import { Progress } from 'antd';
import CashBtnV2 from 'assets/Icons/cashBtnV2';
import DiscountBtnV2 from 'assets/Icons/discountBtnV2';
import IcCoupon from 'assets/Icons/IcCoupon';
import Box from 'components/Box';
import Text from 'components/Text';
import reportSelectors from 'features/report/services/selectors';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';

const Deductions = () => {
  const summarySalon = reportSelectors.getSummarySalon();

  const deductionItems = [
    {
      key: 'discountManual',
      label: 'Manual Discounts',
      value: summarySalon?.discountManual ?? 0,
      icon: <DiscountBtnV2 fill='#C84B31' width='24' height='24' />,
    },
    {
      key: 'discountCoupon',
      label: 'Coupons',
      value: summarySalon?.discountCoupon ?? 0,
      icon: <IcCoupon />,
    },
    {
      key: 'discountIncentive',
      label: 'Cash Incentives',
      value: summarySalon?.discountIncentive ?? 0,
      icon: <CashBtnV2 fill='#C84B31' width='22' height='22' />,
    },
  ];

  const total = summarySalon?.discount ?? 0;
  return (
    <Container>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Text variant='H7' color='text_3'>
          Deductions
        </Text>
        <TotalBox>
          <Text variant='CONTENT_3'>Total:</Text>
          <Text variant='H5' color='v2_primary_bg_6'>
            {formatCurrency(summarySalon?.deductions || 0) || '$0.00'}
          </Text>
        </TotalBox>
      </Box>
      <Content>
        {deductionItems.map((item) => {
          const percent = total > 0 ? (item.value / total) * 100 : 0;

          return (
            <DeductionRow key={item.key}>
              <Box display='flex' alignItems='center' gap='2' width='220px'>
                <IconBox>{item.icon}</IconBox>
                <Text variant='H9' style={{ fontWeight: 500 }}>
                  {item.label}
                </Text>
              </Box>

              <ProgressWrapper>
                <Progress percent={percent} showInfo={false} strokeColor='#d84b52' trailColor='#FFF1F6'/>
              </ProgressWrapper>

              <Text variant='H9' style={{ width: '100px', textAlign: 'right' }}>
                {formatCurrency(item.value)}
              </Text>
            </DeductionRow>
          );
        })}
      </Content>
    </Container>
  );
};

export default Deductions;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e9edf2;
  background: #fff;
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.15);
  font-family: Poppins;
`;

const TotalBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 4px 8px;
  background: #ffe5e7;
  border-radius: 8px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const DeductionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
  height: 56px;
`;

const IconBox = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff1f6;
  border-radius: 100px;
`;

const ProgressWrapper = styled.div`
  flex: 1;
`;
